import React from 'react';
import PageTitle from '../../layouts/PageTitle';

const RevenuHour = () => {
    return (
        <div className='revenue'>
          
            <PageTitle
                title="Reports"
                subtitle="Revenue by hour"
            />

            <div className='date_select'>
                <select className='border-0' name="week" id="week" style={{ width: '60px' }}>
                    <option value="" selected>Today</option>
                    <option value="">Yesterday</option>
                    <option value="">This week</option>
                    <option value="">Last week</option>
                    <option value="">Custom</option>
                </select>
            </div>

            <div className='card-header top-portion mt-2 px-0'>
                <div className="row w-100 m-0">
                    <div className="col-md-6 col-lg-6">
                        <h3>Revenue</h3>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <i className="mdi mdi-download mdi-24px"></i>
                        <i className="mdi mdi-send ml-3"></i>
                    </div>
                </div>
            </div>
            <div className="card-body rounded-0">
                 
            </div>
            
        </div>
    );
};

export default RevenuHour;